import { render, staticRenderFns } from "./type-edit.vue?vue&type=template&id=7e7f3fcf&scoped=true"
import script from "./type-edit.vue?vue&type=script&lang=js"
export * from "./type-edit.vue?vue&type=script&lang=js"
import style0 from "./type-edit.vue?vue&type=style&index=0&id=7e7f3fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7f3fcf",
  null
  
)

export default component.exports